import Login from './components/Login';

export default Login;



// WEBPACK FOOTER //
// ./src/components/login/index.jsx